import { Component } from '@angular/core';
import { ConfigService } from '@aiwyn/config';

@Component({
  selector: 'app-under-maintenance-page',
  templateUrl: './under-maintenance-page.component.html',
  styleUrls: ['./under-maintenance-page.component.scss'],
  standalone: false,
})
export class UnderMaintenancePageComponent {
  constructor(readonly configService: ConfigService) { }
}
